<template>
  <div>
    <b-navbar toggleable="lg" variant="light">
      <b-container>
        <b-navbar-brand to="/"><b>Knewh Admin</b></b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav>
            <b-nav-item to="/" :active="$route.name == 'Hotels DB'">Hotels DB</b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav>
            <b-nav-item to="/find_by_ids" :active="$route.name == 'Hotel By IDs'">Find by Amadeus IDs</b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav>
            <b-nav-item to="/search" :active="$route.name == 'Search'">Search</b-nav-item>
          </b-navbar-nav>

          <!-- <b-navbar-nav class="ml-auto">
                        <b-nav-item-dropdown right>
                            <template slot="button-content">Account</template>
                            <b-dropdown-item href="#">Profile</b-dropdown-item>
                            <b-dropdown-item href="#">Sign Out</b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-navbar-nav> -->
        </b-collapse>
      </b-container>
    </b-navbar>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue